import React, { useEffect, useRef, useState } from 'react'
import HeaderUser from '../components/homePage/HeaderUser'
import FooterPage from '../components/homePage/FooterPage'
import InboxLeftSideBar from '../components/inbox/InboxLeftSideBar'
import { useSelector } from 'react-redux';
import { ageCalculate, allWordMask, checkCustomerIdShowHide, checkIncomeShowHide, checkNameShowHide, checkWorkWithShowHide, decimalToFeetInches, nameMask } from '../utils/utils'
import { Link } from 'react-router-dom';
import ConfirmPopup from '../components/homePage/ConfirmPopup';
import Cookies from "js-cookie";
import InboxDeclined from './InboxDeclined';
import SuccessPopup from '../components/homePage/SuccessPopup';
import { annualIncomeMap } from '../utils/Helper';

function InboxSent() {
  const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));
  const [pageTitle, setPageTitle] = useState("");
  const { userDetailLogin } = useSelector((state) => state.auth);
  const [meneberList, setMemberList] = useState([]);
  const modalConfirmRef = useRef(null)
  const modalInstanceConfirm = useRef(null);
  const [popupMessage, setPopupMessage] = useState("")
  const [partnerValueId, setPartnerValueId] = useState("")
  const [memberValueId, setMemberValueId] = useState("")
  const [memberValueStatus, setMemberValueStatus] = useState("")
  const [showButton, setShowButton] = useState(1)
  const [tabShow, setTabShow] = useState(true)
  const [isScroll, setIsScroll] = useState(false)

  const [planDetailUser, setPlanDetailUser] = useState({})
  const [totalUserSentInterest, setTotalUserSentInterest] = useState(0)
  const [expiryDate, setExpiryDate] = useState(false)
  const [totalUserView, setTotalUserView] = useState(0)
  const [blurPhoto, setBlurPhoto] = useState(0)

  const modalSuccessRef = useRef(null)
  const modalInstanceSuccess = useRef(null);
  const [successMessage, setSuccessMessage] = useState("")

  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  const endpoint = window.location.pathname.split("/").filter(Boolean).pop();

  const title = {
    sent: "Request Sent",
    accepted: "Accepted",
    received: "Received",
    decline: "Decline"
  };

  // list fetch
  const listMember = async (pageType) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/inbox-sent-pending`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          pageType: pageType,
          page: page,
          //member_id: userDetailLogin._id,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setIsScroll(true)
        setMemberList(data.data);
        setTotalPages(data.totalPages);
        setPage(data.page);
      } else {
        console.error("Error fetching members:", data.error || data.message);
      }
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };


  //cancel request
  const cancelRequestButton = async (partnerId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/cancel-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          member_id: userDetailLogin._id,
          partner_id: partnerId,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setPartnerValueId("")
        setMemberList((prevList) =>
          prevList.filter((member) => member?.partner_id?._id !== partnerId)
        );
        //console.log("Cancel successful:", data);
      } else {
        console.error("Error fetching members:", data.error || data.message);
      }
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  }
  const cancelRequest = async (partnerId) => {
    //console.log(partnerId)
    setPartnerValueId(partnerId)
    setShowButton(1)
    setPopupMessage('are you sure you want to cancel request?')
    modalInstanceConfirm.current?.show();
  };


  useEffect(() => {

    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsScroll(false)

  }, [isScroll]);

  useEffect(() => {
    const newTitle = title[endpoint] || "Inbox";
    setPageTitle(newTitle);
    listMember(endpoint);

    document.title = newTitle;
  }, [endpoint, page]);


  useEffect(() => {
    // Initialize Bootstrap modal once (after first render)
    const modalConfirmEl = document.getElementById("confirmPopupId");
    if (modalConfirmEl) {
      modalInstanceConfirm.current = new window.bootstrap.Modal(modalConfirmEl);
    }


  }, []);

  const yesNoButton = (value) => {

    //console.log('confirm', value)
    if (value === 'Yes') {
      //console.log('yes', partnerValueId)
      cancelRequestButton(partnerValueId)
    }
    modalInstanceConfirm.current?.hide();
  }

  const changeStatusRequestButton = async (id, status) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/status-change`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          id: id,
          status: status,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMemberValueId("")
        setMemberValueStatus("")
        setMemberList((prevList) =>
          prevList.filter((member) => member?._id !== id)
        );
        //console.log("Change request successful:", data);
      } else {
        console.error("Error fetching request:", data.error || data.message);
      }
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  }

  const changeStatus = (id, status) => {
    if (status === 'Accepted') {

      changeStatusRequestButton(id, status)
    } else {
      setMemberValueId(id)
      setMemberValueStatus(status)
      setPopupMessage('are you sure you want to decline request?')
      setShowButton(2)
      modalInstanceConfirm.current?.show();
    }

  }

  const yesNoStatusButton = (value) => {


    if (value === 'Yes') {
      //console.log('yes', partnerValueId)
      changeStatusRequestButton(memberValueId, memberValueStatus)
    }
    modalInstanceConfirm.current?.hide();
  }


  const showPartnerButton = (value) => {
    if (value === 1) {
      setTabShow(false)
    } else {
      setTabShow(true)
    }


  }


  const fetchUserDetailMatch = async (userId) => {

    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    });

    const data = await res.json();
    //console.log(data)
    if (data.status) {

      //console.log('interest', data.data[0])
      const isExpired = new Date(data.data[0].plan_detail?.expiry_date) < new Date();

      setExpiryDate(isExpired)
      setTotalUserSentInterest(data.data[0].interest_user)
      setPlanDetailUser(data.data[0].plan_detail)
      setTotalUserView(data.data[0].total_user_view)


      //let blurPhoto = 0 
      if (!data.data[0]?.plan_detail || Object.keys(data.data[0]?.plan_detail).length === 0 || data.data[0]?.plan_detail?.plan_id?.name === 'Basic' || (data.data[0]?.plan_detail?.plan_id?.name === 'Gold' && data.data[0]?.interest_user > parseInt(data.data[0]?.plan_detail?.send_interest)) || (data.data[0]?.plan_detail?.plan_id?.name === 'Premium' && data.data[0]?.interest_user > parseInt(data.data[0]?.plan_detail?.send_interest)) || (expiryDate && (data.data[0]?.plan_detail?.plan_id?.name === 'Gold' || data.data[0]?.plan_detail?.plan_id?.name === 'Premium'))) {
        //console.log('blur photo')
        //blurPhoto = 1
        setBlurPhoto(1)
      }


    }

  }


  useEffect(() => {

    if (userDetailLogin?._id) {
      fetchUserDetailMatch(userDetailLogin?._id)
    }

  }, [userDetailLogin])



  useEffect(() => {
    // Initialize Bootstrap modal once (after first render)


    const modalSuccessEl = document.getElementById("successPopup");
    if (modalSuccessEl) {
      modalInstanceSuccess.current = new window.bootstrap.Modal(modalSuccessEl);
    }

  }, []);

  const requestPhoto = (member_id, index) => {

    //setLoginProps('reload');
    if (userDetailLogin?._id) {

      sendRequestPhoto(member_id, index);

    } else {

      // modalInstance.current?.show();

      return;

    }

  }

  const sendRequestPhoto = async (member_id, index) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/api/user/send-photo-request`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            member_id: member_id,
            //member_id : member_id 
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // console.log("Interest sent successfully:", data);
        setSuccessMessage("Request a photo send successfully.")
        modalInstanceSuccess.current?.show();
        setTimeout(() => {
          modalInstanceSuccess.current?.hide();
        }, 2000)

        listMember()

      } else {
        console.error("Failed to send request photo:", data.message || data);
      }
    } catch (error) {
      console.error("Error while sending request photo:", error);
    }

  }

  return (
    <>
      <HeaderUser />
      <ConfirmPopup ref={modalConfirmRef} message={popupMessage} yesNoButton={showButton === 2 ? yesNoStatusButton : yesNoButton} />
      <SuccessPopup ref={modalSuccessRef} message={successMessage} />



      <section className="inrbnr">
        <div className="container-fluid con-flu-padd">
          <div className="inrbnrContent">
            <h1>{pageTitle}</h1>
            <ul className="inrbrnNav">
              <li>
                <Link to="/dashboard">
                  <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/home.png`} alt="home icon" />
                </Link>
                <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/arrows.png`} alt="arrows icons" />
              </li>
              <li>
                <Link to="#">Inbox</Link>
                <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/arrows.png`} alt="arrows icons" />
              </li>
              <li>
                <Link to="#">{pageTitle}</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <div className="register-sec ">
          <div className="container-fluid con-flu-padd  ">
            <div className="mx-2  ">
              <div className="row pb-20 pt-40">
                <div className="col-md-3 p-0 ">
                  <InboxLeftSideBar />
                  <div className="img-settings">
                    <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/setting-group.png`} alt="" />
                  </div>
                </div>





                <div className="col-md-9 set-pad-lef ">
                  <div className="navWrapper">
                    <ul className="navcontaienr gap-2 d-flex flex-wrap justify-content-center">
                      <li>
                        {" "}
                        <Link className={`navibtn ${tabShow ? 'active' : ''}`} data-target="#detpro" to="#" onClick={() => showPartnerButton(0)}>
                          {" "}
                          Pending{" "}
                        </Link>{" "}
                      </li>
                      <li>
                        {" "}
                        <Link className={`navibtn ${tabShow ? '' : 'active'}`} data-target="#parterpre" to="#" onClick={() => showPartnerButton(1)}>
                          {" "}
                          Declined{" "}
                        </Link>{" "}
                      </li>
                    </ul>
                  </div>

                  {tabShow &&
                    <div className="sectionTop tabContentBox" id="detpro">

                      {meneberList && meneberList.length > 0 ? (
                        meneberList.map((member, index) => {

                          let profilePhoto;
                          let profilePhotoBlur;
                          let profilePhotoShow;
                          if (member?.partner_id.profile_photo === 1) {
                            profilePhoto = member?.partner_id.photo
                            profilePhotoShow = member?.partner_id.photo
                            profilePhotoBlur = member?.partner_id.photo_blur
                            if (blurPhoto === 1) {
                              profilePhoto = member?.partner_id.photo_blur
                            }
                          } else if (member?.partner_id.profile_photo === 2) {
                            profilePhoto = member?.partner_id.photo1
                            profilePhotoShow = member?.partner_id.photo1
                            profilePhotoBlur = member?.partner_id.photo1_blur
                            if (blurPhoto === 1) {
                              profilePhoto = member?.partner_id.photo1_blur
                            }
                          } else if (member?.partner_id.profile_photo === 3) {
                            profilePhoto = member?.partner_id.photo2
                            profilePhotoShow = member?.partner_id.photo2
                            profilePhotoBlur = member?.partner_id.photo2_blur
                            if (blurPhoto === 1) {
                              profilePhoto = member?.partner_id.photo2_blur
                            }
                          } else if (member?.partner_id.profile_photo === 4) {
                            profilePhoto = member?.partner_id.photo3
                            profilePhotoShow = member?.partner_id.photo3
                            profilePhotoBlur = member?.partner_id.photo3_blur
                            if (blurPhoto === 1) {
                              profilePhoto = member?.partner_id.photo3_blur
                            }
                          } else if (member?.partner_id.profile_photo === 5) {
                            profilePhoto = member?.partner_id.photo4
                            profilePhotoShow = member?.partner_id.photo4
                            profilePhotoBlur = member?.partner_id.photo4_blur
                            if (blurPhoto === 1) {
                              profilePhoto = member?.partner_id.photo4_blur
                            }
                          } else {
                            profilePhoto = member?.partner_id.photo
                            profilePhotoShow = member?.partner_id.photo
                            profilePhotoBlur = member?.partner_id.photo_blur
                            if (blurPhoto === 1) {
                              profilePhoto = member?.partner_id.photo_blur
                            }
                          }

                          return (
                            <div className="col-12 mb-4" key={member._id || index} >
                              <div className="res-profiles inboxcont">
                                <div inboxcont className="row">
                                  <div className="col-12 padi-res">
                                    <div className="row">
                                      <div className="col-lg-8 col-md-9  ic-ver-res">
                                        <ul>
                                          <li>

                                            <h4>
                                              <Link to={`/profile-details/${member?.partner_id?._id}`}>
                                                {checkNameShowHide(member?.partner_id?.profileSettings?.name_show, planDetailUser) ? member?.partner_id?.name : nameMask(member?.partner_id?.name)}
                                              </Link>
                                            </h4>
                                          </li>
                                          <li>
                                            <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/verified.png`} alt="" />
                                          </li>
                                          <li className="profil-id-re">( ID :&nbsp;{checkCustomerIdShowHide(member?.partner_id?.profileSettings?.customer_id_show, planDetailUser) ? member?.partner_id?.profile_id : allWordMask(member?.partner_id?.profile_id)} )</li>
                                        </ul>
                                      </div>
                                      <div className="col-lg-4 col-md-3 res-fl   ">
                                        <ul className="justify-content-lg-end">
                                          <li>
                                            <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/calender.png`} alt="" />
                                          </li>
                                          <li className=""> {new Date(member.createdAt).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short"
                                          })}</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 pad-res-2">
                                    <div className="row">

                                      <div className="col-lg-3 col-xl-2 col-md-4 pe-lg-0">
                                        {member?.partner_id?.profileSettings?.photo_show === 2 || (member?.partner_id?.photo_request_check && member?.partner_id?.photo_request_status === 1) ?
                                          (

                                            <div className='inboximg'>
                                              <Link to={`/profile-details/${member?.partner_id?._id}`}>
                                                <img src={profilePhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}` : (member?.partner_id?.gender == 'Male' ? 'assets/img/no-image.jpg' : 'assets/img/no-image-female.jpg')} alt="" />
                                              </Link>

                                            </div>
                                          )
                                          :

                                          member?.partner_id?.profileSettings?.photo_show === 1 || blurPhoto === 1 ?
                                            (
                                              <div className="inboximg position-relative">
                                                <div className="lockedimage pb-3">
                                                  <img src="assets/img/locked-icon.png" alt='' />


                                                  {member?.partner_id?.profileSettings?.photo_show === 1 ?
                                                    <>
                                                      {member?.partner_id?.photo_request_check ? null :
                                                        <Link to="#" onClick={(e) => {
                                                          e.preventDefault();
                                                          requestPhoto(member?.partner_id._id, index)
                                                        }
                                                        }>Request a Photo</Link>
                                                      }


                                                    </>
                                                    :
                                                    <>
                                                      Visible to
                                                      <br />
                                                      Premium Members
                                                      <a href="/membership-plan">View Plans</a>
                                                    </>
                                                  }
                                                </div>
                                                <Link to={`/profile-details/${member?.partner_id?._id}`} >
                                                  <img src={profilePhotoBlur ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhotoBlur}` : member?.partner_id.gender === 'Male' ? 'assets/img/no-image-male.jpg' : 'assets/img/no-image-female.jpg'} alt="" />
                                                </Link>
                                              </div>
                                            )
                                            :
                                            <div className='inboximg'>
                                              <Link to={`/profile-details/${member?.partner_id?._id}`}>
                                                <img src={profilePhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}` : (member?.partner_id?.gender === 'Male' ? 'assets/img/no-image-male.jpg' : 'assets/img/no-image-female.jpg')} alt="" />
                                              </Link>

                                            </div>

                                        }
                                      </div>
                                      <div className="col-lg-5 col-xl-7 col-md-8 col-xs-12">
                                        <div className="row">
                                          <div className="col-xl-5 col-lg-12">
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Age / Height</span>:
                                              {(member?.partner_id?.dob || member?.partner_id?.height)
                                                ? `${member?.partner_id?.dob ? ageCalculate(member?.partner_id?.dob) : ""}${member?.partner_id?.dob && member?.partner_id?.height ? ", " : ""}${member?.partner_id?.height ? decimalToFeetInches(member?.partner_id.height) : ""}`
                                                : ""}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Religion</span>: {member?.partner_id?.religion?.name}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Cast</span>: {member?.partner_id?.caste?.name}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Gotra</span>: {member?.partner_id?.gotra?.name}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Occupation</span>:
                                              {member?.partner_id?.occupation?.name}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Location</span>:
                                              {[member?.partner_id?.loc_state?.name, member?.partner_id?.loc_city?.name].filter(Boolean).join(", ")}
                                            </div>
                                          </div>
                                          <div className="col-xl-6 col-lg-12">
                                            <div className="profiledata-rowss marg-to d-flex align-items-start">
                                              <span className="fieldname">Education</span>:
                                              {member.partner_id?.highest_degree?.name}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Manglik</span>: {member?.partner_id?.manglik}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Marital Status</span>
                                              :  {member?.partner_id?.marital_status?.name}
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Income</span>:

                                              {
                                                checkIncomeShowHide(
                                                  member?.partner_id?.profileSettings?.income_show,
                                                  planDetailUser
                                                )
                                                  ? member?.partner_id?.annual_income
                                                    ? annualIncomeMap(member.partner_id.annual_income)
                                                    : ""
                                                  : member?.partner_id?.annual_income
                                                    ? nameMask(member.partner_id.annual_income)
                                                    : ""
                                              }
                                            </div>
                                            <div className="profiledata-rowss d-flex align-items-start">
                                              <span className="fieldname">Job</span>: {checkWorkWithShowHide(member?.partner_id?.profileSettings?.work_with_show, planDetailUser) ? member?.partner_id?.working_with?.name : allWordMask(member?.member_id?.working_with?.name)}
                                            </div>
                                          </div>
                                        </div>


                                        <p className="invit-res">
                                          <Link to="#" style={{ cursor: 'default' }}>
                                            Your requested here on {new Date(member.createdAt).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric"
                                            })}
                                          </Link>
                                        </p>


                                      </div>
                                      <div className="col-lg-4 col-xs-12 col-md-6 col-xl-3">
                                        <div className="bg-ic-ress text-center px-3">


                                          <div className="butt-res-acc">
                                            <button className="cancel-req my-5" onClick={() => cancelRequest(member?.partner_id?._id)}>
                                              <Link to="#">Cancel Request</Link>
                                            </button>
                                            <br />
                                          </div>




                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>

                          )


                        })
                      ) : (
                        <div className="profilelist-box d-md-flex align-items-md-start justify-content-md-start mb-2">
                          No member found
                        </div>
                      )}

                    </div>
                  }

                  {!tabShow &&
                    <div className="sectionTop tabContentBox" id="parterpre">
                      <InboxDeclined />
                    </div>
                  }



                  {/* pagination */}
                  {totalPages > 1 && (
                    <div className="flex gap-2 mt-4 paging">
                      <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                      >
                        Prev
                      </button>

                      {[...Array(totalPages)].map((_, i) => (
                        <button
                          key={i}
                          onClick={() => setPage(i + 1)}
                          className={page === i + 1 ? "font-bold" : ""}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>




              </div>
            </div>
          </div>
        </div>
      </section>


      <FooterPage />
    </>
  )
}

export default InboxSent
